module.exports = __webpack_public_path__ + "media/styles/images/svg/upload-media-05e518c452bcfb13e8a4e4c225afb89e.svg";